export const SET_OTS_TESTS_DATA = "SET_OTS_TESTS_DATA";
export const SET_OTS_TESTS_RESULT_DATA = "SET_OTS_TESTS_RESULT_DATA";
export const SET_OTS_PLANNER_DATA = "SET_OTS_PLANNER_DATA";
export const SET_OTS_PAGE_NUM = "SET_OTS_PAGE_NUM";
export const SET_OTS_PREMIUM_DATA = "SET_OTS_PREMIUM_DATA";
export const SET_OTS_FREE_DATA = "SET_OTS_FREE_DATA";
export const SET_OTS_TESTS_PAPER_RESULT_DATA =
  "SET_OTS_TESTS_PAPER_RESULT_DATA";
